const util = require('util');
const Utils = require('../Utils');
const RingBuffer = require('../RingBuffer');

class LogStore {
  /**
   * Records log events in an array or ring buffer.
   *
   * @param {number} maxRecords the size of the ring buffer.
   * @constructor
   */
  constructor(maxRecords) {
    this.logRecords = maxRecords ? new RingBuffer(maxRecords) : [];
  }

  onLog(component, level, data, time) {
    this.logRecords.push({
      time, component, level, data,
      toString: logRecordToString,
    });
  }

  /**
   * @returns {string[]} all messages currently stored.
   */
  allMessages() {
    const result = [];
    this.logRecords.forEach((record) => {
      result.push(record);
    });
    return result;
  }

  toString() {
    return `Stored Log Messages:\n\t ${this.allMessages().join('\n\t')}`;
  }
}

function logRecordToString() {
  const prefix = Utils.templateFormatter(this.time, this.component, this.level);
  return `${prefix} ${util.format(...this.data)}`;
}

module.exports = LogStore;
